export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <img
              src="https://static.readdy.ai/image/6ae913d34dc5289e66b9f22e1ec27e15/22c22442c4d57f6bf0d57c097e0b2690.jpeg"
              alt="Talleres Lujambio"
              className="h-24 w-auto mb-4 object-contain"
            />
            <p className="text-gray-400 text-sm leading-relaxed">
              Referencia en el sector industrial con casi medio siglo de experiencia en mecanizado y construcción mecánica.
            </p>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Especialidades</h3>
            <ul className="space-y-2 text-gray-400 text-sm">
              <li>Mecanizado de Precisión</li>
              <li>Equilibrado Industrial</li>
              <li>Enderezado</li>
              <li>Pulido Industrial</li>
              <li>Construcción Mecánica</li>
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Contacto</h3>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-teal-500 mr-2 mt-1"></i>
                <span>Polígono Industrial Eziago 35<br />20120 Hernani, Gipuzkoa</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line text-teal-500 mr-2"></i>
                <a href="tel:+34943554787" className="hover:text-teal-500 transition-colors">
                  943 55 47 87
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-global-line text-teal-500 mr-2"></i>
                <a href="http://www.tallereslujambio.com" target="_blank" rel="noopener noreferrer" className="hover:text-teal-500 transition-colors">
                  www.tallereslujambio.com
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-linkedin-box-fill text-teal-500 mr-2"></i>
                <a href="https://es.linkedin.com/company/tallereslujambio" target="_blank" rel="noopener noreferrer" className="hover:text-teal-500 transition-colors">
                  LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-gray-400 text-sm text-center md:text-left">
              © {currentYear} Talleres Lujambio, S.L. Todos los derechos reservados.
            </p>
            <div className="flex items-center gap-6 text-sm">
              <a 
                href="/proteccion-de-datos" 
                className="text-gray-400 hover:text-teal-500 transition-colors whitespace-nowrap"
              >
                Protección de Datos
              </a>
              <a 
                href="/politica-de-cookies" 
                className="text-gray-400 hover:text-teal-500 transition-colors whitespace-nowrap"
              >
                Política de Cookies
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
